import { MediaPageFormDataWithName } from '@features/Funnel/screens/FunnelPage/MediaPage/MediaPageScreen';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import OpenNotification from 'src/app/components/antd/OpenNotification';

import { apiCancellationFunnels } from '../../api';
import { mediaPayloadFunnelsPageFactory } from '../../utils/mediaFunnelsPageFactory';

interface UpdateMediaFunnelPageRequest {
  id: string;
  payload: MediaPageFormDataWithName;
}

export function useTryToRequestMediaQuestionPage() {
  const navigate = useNavigate();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ id, payload }: UpdateMediaFunnelPageRequest) => {
      const factory = await mediaPayloadFunnelsPageFactory(payload);

      return await apiCancellationFunnels.tryToRequestUpdateCancellationFunnelPage(
        id,
        factory
      );
    },
    onSuccess: () => {
      navigate(-1);
    },
    onError: () => {
      OpenNotification(
        true,
        'Erro ao editar o funil de Perguntas',
        'Ocorreu um erro ao editar o funil de Perguntas, por favor tente novamente mais tarde.'
      );
    },
  });

  return {
    tryToRequestUpdateMediaPage: mutateAsync,
    isLoadingMediaUpdate: isPending,
  };
}
